import React from 'react'

import podcast from '../images/projects/podcast.png'
import shouldiuse from '../images/projects/shouldiuse.png'

import Box from '../styled/Box'
import Project from '../components/Project'

const LINKS = {
  podcast: 'https://podcasts.apple.com/us/podcast/id1478302893',
  siu: 'https://shouldiuse.app',
}

function ProjectsBlurb(props = {}) {
  return (
    <>
      <Box mb="xl">
        <Project
          title="Product Conversations"
          image={podcast}
          link={LINKS.podcast}
        >
          <Box as="p" mb="base">
            A podcast that demystifies how great digital products are made by
            answering questions about building digital products.
          </Box>
        </Project>
      </Box>
      <Box mb="xl">
        <Project title="Should I Use?" image={shouldiuse} link={LINKS.siu}>
          <Box as="p">
            A web application that aims to help developers evaluate what
            JavaScript packages to use based on a baseline set of criteria.
          </Box>
        </Project>
      </Box>
    </>
  )
}

export default ProjectsBlurb
